<div *ngIf="data && datum; else loadingTemplate">
  <ejs-dropdowntree
    [fields]="fields"
    [value]="value"
    [itemTemplate]="itemTemplate"
    [placeholder]="placeholder"
    [allowFiltering]="true"
    [showClearButton]="false"
    [floatLabelType]="'Always'"
    filterType="Contains"
    cssClass="app-dropdown-tree"
    (select)="select.emit($event.itemData.id)"
  ></ejs-dropdowntree>
</div>

<ng-template #loadingTemplate>
  <app-skeleton></app-skeleton>
</ng-template>
